import MileageDictionaryDetailsRequest from "../../../../api/raily/mileage/dictionary/details/mileage-dictionary-details.request";
import MileageDictionaryDetailsParams from "./mileage-dictionary-details-params";

const create = (
  params: MileageDictionaryDetailsParams,
): MileageDictionaryDetailsRequest => {
  return {
    cargoCompanyUuid: params.cargoCompanyUuid,
    recordUuid: params.recordUuid,
  };
};

const mileageDictionaryDetailsParamsFactory = {
  create,
};

export default mileageDictionaryDetailsParamsFactory;
